import Backbone from "backbone";
import * as logger from "./utils/logger";
import { dispatcher, DispatcherEvents } from "./utils/dispatcher";
import { isDriverOnWorkflow, isDriverDoingNestedWorkflow, decodeUri, IRouterPageState, INSPECTION_HISTORY_DETAILS_ROUTE } from "./utils/uri";
import DriveView from "./DriveView";
import { extend } from "./utils/vanilla";
import rison from "rison";
import AppView from "./app.view";
import { MobileActions } from "./store/mobile/actions";
import { getPin, NO_PIN_VALUE, removePin } from "./ui/inspection/inspectionHelper";
import WorkflowView, { TWorkflowStep, IWorkflowState } from "./ui/workflow";
import AddinView from "./ui/addin";
import { getAddinConfig } from "./utils/addinHelper";
import LoginView from "./ui/login";
import DashboardView from "./ui/main";
import AssetsView from "./ui/assets/main";
import ManageShipmentsView from "./ui/assets/manageShipments";
import ManageTrailersView from "./ui/assets/manageTrailers";
import SelectShipmentsView from "./ui/assets/selectShipment";
import SelectTrailerView from "./ui/assets/selectTrailer";
import SelectVehicleView from "./ui/assets/selectVehicle";
import { SuggestedVehicles } from "./ui/assets/suggestedVehicle";
import AddInTest from "./ui/debug/addin";
import BackgroundTestView from "./ui/debug/backgroundTest";
import DebugLogsView from "./ui/debug/debugLogs";
import DrivingSimulatorView from "./ui/debug/drivingSimulator";
import ErrorsView from "./ui/debug/errors";
import WebSocketDebugView from "./ui/debug/webSocketDebug";
import FeatureFlagsView from "./ui/debug/featureFlags";
import FlagsView from "./ui/debug/flags";
import GpsView from "./ui/debug/gps";
import ImageDebug from "./ui/debug/imagesDebug";
import IoxUsbView from "./ui/debug/ioxUsb";
import LocalStorageView from "./ui/debug/localStorage";
import DebugView from "./ui/debug/main";
import MocksView from "./ui/debug/mocks";
import NativeView from "./ui/debug/native";
import NotificationsView from "./ui/debug/notifications";
import AppCacheView from "./ui/debug/offline";
import StatusView from "./ui/debug/status";
import VehicleProximityView from "./ui/debug/vehicleProximity";
import InspectDvirView from "./ui/dvir/inspect";
import DvirView from "./ui/dvir/main";
import ViewDvirView from "./ui/dvir/view";
import { GraphView } from "hos-tools/src/graphView/graphView";
import LockView from "./ui/hos/lock";
import AddLogView from "./ui/hos/tabs/logs/addLog";
import LogsView from "./ui/hos/tabs/logs/logs";
import ViewHosView from "./ui/hos/tabs/logs/view";
import HosEldMalfunctionView from "./ui/hos/tabs/logs/eldmalfunctions/malfunction";
import HosView from "./ui/hos/tabs/main/main";
import InspectionView from "./ui/inspection/main";
import HosReportView from "./ui/inspection/hos/report";
import TransferView from "./ui/inspection/hos/transfer";
import MessagesView from "./ui/messaging/main";
import ViewMessageView from "./ui/messaging/view";
import OtherMenuView from "./ui/other/main";
import SettingsView from "./ui/settings/main";
import ChangePasswordView from "./ui/settings/passwordChange";
import TripsCategorizationView from "./ui/trips/main";
import RuleSetChangeView from "./ui/framework/ruleSetChangeView";
import EventsView from "./ui/notifications/events";
import EventView from "./ui/notifications/event";
import EmailHOSLogsView from "./ui/emailLogs/main";
import ChangeLanguageView from "./ui/settings/languageChange";
import ChangeTimezoneView from "./ui/settings/timezoneChange";
import ChangeHomeTerminalView from "./ui/settings/homeTerminalChange";
import { FeatureFlagName } from "./utils/featureFlagName";
import LogsReviewChangesView from "./ui/hos/tabs/logs/logsReviewChanges";
import { stopAllSpinners } from "./utils/spinner";
import constants from "./constants";
import { ErrorTracker } from "./utils/errorHandler/errorTracker";

const defaultPage = `login,${ rison.encode({ loggingIn: true }) }`;
export const MESSAGING_URL = "messaging/main";

export class Router extends Backbone.Router {

    driveApp: AppView;
    private currentPage: string | undefined;

    private readonly pageModules: { [key: string]: any} = {

        "ui/addin": AddinView,
        "ui/login": LoginView,
        "ui/main": DashboardView,
        "ui/workflow": WorkflowView,

        "ui/assets/main": AssetsView,
        "ui/assets/manageShipments": ManageShipmentsView,
        "ui/assets/manageTrailers": ManageTrailersView,
        "ui/assets/selectShipment": SelectShipmentsView,
        "ui/assets/selectTrailer": SelectTrailerView,
        "ui/assets/selectVehicle": SelectVehicleView,
        "ui/assets/suggestedVehicle": SuggestedVehicles,

        "ui/debug/addin": AddInTest,
        "ui/debug/backgroundTest": BackgroundTestView,
        "ui/debug/debugLogs": DebugLogsView,
        "ui/debug/drivingSimulator": DrivingSimulatorView,
        "ui/debug/errors": ErrorsView,
        "ui/debug/featureFlags": FeatureFlagsView,
        "ui/debug/flags": FlagsView,
        "ui/debug/gps": GpsView,
        "ui/debug/imagesDebug": ImageDebug,
        "ui/debug/ioxUsb": IoxUsbView,
        "ui/debug/localStorage": LocalStorageView,
        "ui/debug/main": DebugView,
        "ui/debug/mocks": MocksView,
        "ui/debug/native": NativeView,
        "ui/debug/notifications": NotificationsView,
        "ui/debug/offline": AppCacheView,
        "ui/debug/status": StatusView,
        "ui/debug/vehicleProximity": VehicleProximityView,
        "ui/debug/webSocketDebug": WebSocketDebugView,

        "ui/dvir/inspect": InspectDvirView,
        "ui/dvir/main": DvirView,
        "ui/dvir/view": ViewDvirView,

        "ui/framework/ruleSetChangeView": RuleSetChangeView,

        "ui/hos/graph": GraphView,
        "ui/hos/lock": LockView,
        "ui/hos/tabs/logs/addLog": AddLogView,
        "ui/hos/tabs/logs/logs": LogsView,
        "ui/hos/tabs/logs/logsReviewChanges": LogsReviewChangesView,
        "ui/hos/tabs/logs/view": ViewHosView,
        "ui/hos/malfunctions": HosEldMalfunctionView,
        "ui/hos/tabs/main/main": HosView,

        "ui/emailLogs/main": EmailHOSLogsView,

        "ui/inspection/main": InspectionView,
        "ui/inspection/hos/report": HosReportView,
        "ui/inspection/hos/transfer": TransferView,

        "ui/messaging/main": MessagesView,
        "ui/messaging/view": ViewMessageView,

        "ui/notifications/events": EventsView,
        "ui/notifications/event": EventView,

        "ui/other/main": OtherMenuView,

        "ui/settings/main": SettingsView,
        "ui/settings/homeTerminalChange": ChangeHomeTerminalView,
        "ui/settings/languageChange": ChangeLanguageView,
        "ui/settings/passwordChange": ChangePasswordView,
        "ui/settings/timezoneChange": ChangeTimezoneView,

        "ui/trips/main": TripsCategorizationView
        // ###############################################################################################
        // ||                                                                                           ||
        // || Router hookups for Geotab Drive Modules.                                                  ||
        // || Note when creating a dashboard tile that the `id` of the <a> root element of the          ||
        // || dashboard tile must match the entry here.                                                 ||
        // ||                                                                                           ||
        // || see                                                                                       ||
        // ||     app/ui/main.ts --> navigateModule                                                     ||
        // ||     app/ui/main.ts --> render (section "Conditions & data for Geotab Drive Modules        ||
        // ||     dashboard tiles")                                                                     ||
        // ||     app/ui/main.tmpl --> section "Dashboard tiles for Geotab Drive Modules"               ||
        // ||     app/router.ts (this file) --> getAliases (section "Aliases for Geotab Drive Modules") ||
        // ||                                                                                           ||
        // ###############################################################################################
    };

    constructor(driveApp: AppView, private readonly errorTracker?: ErrorTracker) {
        super();

        this.route(/^(.*?)(,(.*))?$/, "loadPage");
        this.driveApp = driveApp;

        window.addEventListener("popstate", e => {
            // Disable back button on workflow
            if (isDriverOnWorkflow() && !isDriverDoingNestedWorkflow()) {
                window.history.pushState(extend(e.state || {}, {
                    randomNumber: Math.random()
                }), document.title, window.location.href);
            }
        });
    }

    /**
     * Checks if the given view is a Backbone view definition (e.g. class AbcView extends DriveView {})
     * @param viewDefinition - The view definition to check. Not looking for instances, but rather the class definition.
     * @returns A boolean indicating whether the view is a Backbone view definition.
     */
    static isBackboneViewDefinition(viewDefinition: any): boolean {
        return !!viewDefinition && viewDefinition.prototype instanceof Backbone.View;
    }

    /**
     * Checks if the given view is an instance of Backbone.View.
     * @param view - The view to check.
     * @returns `true` if the view is an instance of Backbone.View, `false` otherwise.
     */
    static isBackboneViewInstance(view: any): boolean {
        return view instanceof Backbone.View;
    }

    navigateToPage(fragment: string, pageArgs?: {}) {
        let args = pageArgs ? `,${ rison.encode(pageArgs) }` : "";
        this.navigate(`${ fragment }${ args }`, true);
    }

    toWorkflow(isLogout = false, nextPageState: IWorkflowState = {}, skipWorkflow?: boolean) {
        let step: TWorkflowStep;
        if (isLogout) {
            step = "checkPostTrip";
        } else {
            // Codriver clocking in, then skip to verify logs
            if ((nextPageState && nextPageState.coDriver)) {
                step = "showAvailability";
            } else if ((nextPageState && nextPageState.step)) {
                step = nextPageState.step;
            } else {
                step = "selectVehicle";
            }
        }

        // Override the step
        nextPageState.step = step;
        nextPageState.isLogout = isLogout;
        if (skipWorkflow) {
            nextPageState.skipWorkflow = true;
        }
        dispatcher.trigger(DispatcherEvents.HideToastMessage);
        this.navigate("workflow," + rison.encode(nextPageState), true);
    }

    /**
     * Resolves a page alias or shortcut, mapping it to a real page
     * @param pageName The page alias shortcut to map to a real page
     * @param pageState The current page state to pass along
     * @returns The new page and state
     */
    resolveAlias (pageName: string, pageState: IRouterPageState) {
        let page = pageName;
        let state = pageState;
        let loginPage = /^login\/(.+)/.exec(page);
        let supportedPageAliases: { [key: string]: string } = this.getAliases();

        if (loginPage) {
            if (loginPage[1]) {
                state = state || {};
                state.next = loginPage[1];
            }
            page = "login";
        }

        // Supported page aliases
        if (page in supportedPageAliases) {
            page = supportedPageAliases[page];
        }

        return { page, state };
    }

    /**
     * This overrides the router's execute method and check current module for onBeforeNavigate property that must return promise.
     * (if promise is resolved - proceed with navigation, if rejected - return to the current page)
     * @param callback The navigation action to perform on success
     * @param args The page arguments
     * @param name The page name
     */
    execute (callback: Function, args: any[], _: string) {
        let canNavigateChecker = this.driveApp.getNavigationLocker();
        let newHash: string = Backbone.history.getHash();

        //editing logs/inspection mode are the only pages that need this behaviour (don't rerender if same page), kinda hacky but not a worthwhile tradeoff to disable it
        let noRefresh: string[] = ["hos/tabs/logs/view", "inspection/main"];
        let isNoRefresh = () => noRefresh.some(noRefreshURL => newHash.indexOf(noRefreshURL) > -1);

        if (newHash !== this.currentPage) {
            if (canNavigateChecker) {
                canNavigateChecker()
                .then(() => {
                    callback.apply(this, args);
                })
                .catch(() => {
                    window.location.hash = `#${ this.currentPage }`;
                });

                return false;
            } else {
                callback.apply(this, args);
            }
        } else {
            if (!isNoRefresh()) {
                callback.apply(this, args);
            }
            return false;
        }

        return undefined;
    }

    isMissingPage(page: string) {
        if (page === "" || !page) {
            let passedInUrl: string = window.getPassedInUrl ? window.getPassedInUrl() : (window.getTempStorage ? window.getTempStorage("passedUrl") : null);
            let hasCustomUrlScheme = false;
            if (passedInUrl) {
                hasCustomUrlScheme = passedInUrl.indexOf("geotabdrive://") !== -1;
                passedInUrl = passedInUrl.replace("geotabdrive://", "");
                if (self !== top) {
                    window.parent.postMessage({
                        type: "drive:settempstorage",
                        key: "passedUrl",
                        value: null
                    }, "file:///");
                }
            }
            let hasPassedInUrlLength = passedInUrl ? passedInUrl.length : 0;
            this.logLoginViewEvent(`Missing page, redirecting to default page. hasCustomUrlScheme: ${ hasCustomUrlScheme } hasPassedInUrl: ${ hasPassedInUrlLength }`);
            this.navigate(hasPassedInUrlLength ? passedInUrl : defaultPage, true);
            return true;
        }
        return false;
    }

    isSuspiciousPath(page: string) {
        let pathHasUpperFolderSymbol = /(\.\.[\/\\])/g.test(page);
        let isScriptsRequest = page.toLowerCase().indexOf("requiredscripts") !== -1;
        let isPageWithQueryParameters = page.indexOf("?") !== -1;

        // this url looks suspicious, better reset it and send back to login
        if (pathHasUpperFolderSymbol || isScriptsRequest || isPageWithQueryParameters) {
            // eslint-disable-next-line max-len
            this.logLoginViewEvent(`Suspicious path detected: pathHasUpperFolderSymbol: ${ pathHasUpperFolderSymbol } isScriptsRequest: ${ isScriptsRequest } isPageWithQueryParameters:${ isPageWithQueryParameters }`);
            this.navigate(defaultPage, true);
            return true;
        }
        return false;
    }

    isLoginPage(page: string) {
        return /((?:ui\/)|^)+login|-\/login/.test(page);
    }

    /**
     * Loads the page
     * @param pageName The page name
     * @param d The page state, including trailing comma
     * @param pageState The page state
     */
    // eslint-disable-next-line complexity
    loadPage (pageName: string, _: string, pageState?: string) {
        let page = pageName ? decodeUri(pageName) : pageName;

        if (this.isMissingPage(page) || this.isSuspiciousPath(page)) {
            return;
        }

        if (this.errorTracker) {
            this.errorTracker.configureRouting(page);
        }

        const isLogin = this.isLoginPage(page);
        let isDebugPage = /((?:ui\/)|^)+debug/.test(page);
        // "inspections/historyDetails" is included so the roadside last-inspection redirect
        // (MYG-141213) can open the read-only Inspection History Detail page without being
        // bounced back to inspection/main while a Roadside Check PIN is active.
        let isInspectionPage = /((?:ui\/)|^)+inspection/.test(page) || page.includes("inspection/main") || page.includes("inspection/report") || page.includes(INSPECTION_HISTORY_DETAILS_ROUTE);
        let state: IRouterPageState = pageState && rison.decode(decodeURIComponent(pageState)) || {};

        // Embedded page mode
        if (state.embed) {
            // Enable the super secret embedded mode (A.K.A. don't share this with anyone yet)
            this.driveApp.store.dispatch(MobileActions.setEmbed(true));
        }

        // Aliasing for deep linking
        let originalPage = page;
        let { page: resolvedPage, state: resolvedState } = this.resolveAlias(page, state);
        page = resolvedPage;
        state = resolvedState;

        // New-format URL handling
        let pageMatch = /^ui\//g.test(page);
        if (!pageMatch) {
            page = `ui/${ page }`;
        }

        const hasCredentialsInPageState = this.isStateWithCredentials(state);
        const stateWithoutCredentials = this.getPageStateWithoutCredentials(state);

        let currentUser = this.driveApp.userService.getCurrentUser();
        let currentUserId = currentUser ? currentUser.id : undefined;
        let inspectionPin = currentUserId && getPin(this.driveApp.store, currentUserId, true);

        if (hasCredentialsInPageState) {
            // Always log when a page is launched with credentials
            const resolvedPageText = originalPage !== page.replace("ui/", "") ? ` (resolved to "${ page }")` : "";
            logger.event(
logger.Event.SSOPAGELAUNCH,
                `Launched on page "${ originalPage }"${ resolvedPageText } with state: ${ JSON.stringify(stateWithoutCredentials) } with server: ${ location.host }`
);
        }

        if (!isLogin && hasCredentialsInPageState) {
            if (this.isAlreadyLoggedIn(state)) {
                this.logLoginViewEvent(`loadPage into app with creds but already logged in`);
                this.navigateToPage(page, stateWithoutCredentials);
                return;
            }
            this.logLoginViewEvent(`loadPage into app with creds but not logged in - sent to LoginView`);
            let params = this.getLoginParams(page, state);
            this.navigate(`login,${ rison.encode(params) }`, true);
        } else if (!isLogin && !isDebugPage && !this.driveApp.userService.hasLoggedInUser()) {
            this.logLoginViewEvent(`loadPage into app without logged in users`);
            let loginState = {
                loggingIn: true,
                cleanUp: !!state.cleanUp
            } as IRouterPageState;
            if (page.indexOf("workflow") === -1 && page.indexOf(constants.ZENITH_ROUTE) === -1) {
                // Do not pass next parameter temporarily until Zenith login page is enabled
                const hasPageState = Object.keys(stateWithoutCredentials).length > 0;
                loginState.next = hasPageState ? `${ page },${ rison.encode(stateWithoutCredentials) }` : page;
            }

            this.navigate(`login,${ rison.encode(loginState) }`, true);
        } else if (inspectionPin && !isInspectionPage && !isLogin) {
            if (inspectionPin === NO_PIN_VALUE) {
                currentUserId && removePin(this.driveApp.store, currentUserId);
                this.navigateIfPermitted(page, state, currentUser);
            } else {
                this.navigateToPage("inspection/main");
            }
        } else {
            this.navigateIfPermitted(page, state, currentUser);
        }
    }

    navigateIfPermitted(page: string, state: IRouterPageState, currentUser: ReturnType<typeof this.driveApp.userService.getCurrentUser>) {
        if (this.driveApp.securityService?.canNavigate(page) && this.canOpenAddinPage(page, state)) {
            // TODO: Remove the setTimeout below in MYG-36891: https://jira.geotab.com/browse/MYG-36891
            setTimeout(() => this.renderPage(page, state), 0);
        } else {
            logger.log(logger.Source.ROUTER, `User doesn't have permission to visit page "${ page }"`, currentUser);
            window.history.back();
        }
    }

    /**
     * An add-in page opens only for an add-in the current driver can see: the same list the dashboard shows,
     * filtered by the add-in's view clearance and by whether it is signed. Other pages are not affected.
     */
    canOpenAddinPage(page: string, state: IRouterPageState): boolean {
        if (page !== "ui/addin") {
            return true;
        }

        let addinName: string;
        try {
            addinName = atob(state.addinName ?? "");
        } catch {
            return false;
        }

        return !!getAddinConfig(addinName, this.driveApp.databaseCache, this.driveApp.userService.getCurrentUser());
    }

    /**
     * Renders a page from a specified page name string and state.
     * The `page` maps to the Backbone or React components in `pageModules`.
     * AppView's `contentView` will be set (incl previously removing the current view if it exists).
     * Lastly the `contentView` will be rendered in the `AppView.render` method.
     *
     * @param page - The name of the page to render. Must be a key in `pageModules`.
     * @param state - The state of the page.
     * @throws Error if the page cannot be resolved.ç
     * @throws Error if the page is not an instance of DriveView or a React element.
     */
    renderPage(page: string, state: IRouterPageState) {
        // Any URL containing ZENITH_ROUTE (e.g. "/-/") is a React page — Backbone router
        // picks it up when React Router navigates internally (e.g. /#/-/hos/addLog).
        if (page.indexOf(constants.ZENITH_ROUTE) > -1 ||
            page.indexOf("driverSafety") > -1 ||
            (this.driveApp.featureFlagService.hasFeatureFlag(FeatureFlagName.ENABLE_COACHING_MODULE) && page.indexOf("coaching") > -1) ||
            page.indexOf("inspections") > -1 ||
            page.indexOf(constants.COLD_CHAIN_ROUTE) > -1
        ) {
            this.driveApp.removeContentView();

            // Hide Backbone UI container when viewing a React page
            // Keep root visible but only hide/show the content area
            document.getElementById("main")?.classList.add("hidden");
            document.getElementById("root")?.classList.remove("hidden");

            stopAllSpinners();
            this.notifyDriveNativeOfInspectionsPage(page);
            // Update currentPage so that pressing back from a React page causes
            // execute() to see newHash !== currentPage and re-render the previous
            // Backbone page. Without this, currentPage stays at the pre-React value,
            // execute() hits the noRefresh path and skips rendering (leaving #main empty).
            this.currentPage = Backbone.history.getHash();
            return;
        }
        // Restore Backbone UI container when viewing a Backbone page
        document.getElementById("main")?.classList.remove("hidden");
        document.getElementById("root")?.classList.add("hidden");

        // Looks up the page in the `pageModules` dictionary to match with their class
        // If it can't resolve the page, please add the page (& import) to the `pageModules` array
        let pageConstructor = this.getPageModule(page);
        if (!pageConstructor) {
            logger.log(logger.Source.ROUTER, `Unknown page "${ page }", redirecting to main screen`);
            this.navigate("main", { trigger: true, replace: true });
            return;
        }

        let contentView = this.driveApp.contentView;

        if (contentView && Router.isBackboneViewInstance(contentView)) {
            this.driveApp.removeContentView();
            const isSamePageNavigation = this.driveApp.cachedContentView &&
                this.driveApp.contentViewCachePath === Backbone.history.fragment;
            if (!isSamePageNavigation) {
                this.driveApp.cachedContentView = null;
            }
        }

        let view: DriveView<Backbone.Model> | undefined;
        if (Router.isBackboneViewDefinition(pageConstructor)) {
            view = new pageConstructor({
                app: this.driveApp,
                state,
                el: "#content"
            });
        }

        logger.log(logger.Source.ROUTER, `Loaded page '${ page }'`);

        // TODO: MYG-17620 - Remove this eslint-disable-next-line when Gitlab VM has latest NodeJs/NPM version
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        this.driveApp.contentView = view as any;    //TODO: MYG-17620 - Fix this type issue once React is stable
        this.driveApp.render();
        dispatcher.trigger(DispatcherEvents.ViewPageloaded, page);
        this.currentPage = Backbone.history.getHash();
    }

    /**
     * React pages skip ViewPageloaded, so DriveNative could not title Asset Inspection pages or hide its footer on them.
     * Report them directly: ViewPageloaded would also run dashboard add-in startup.
     * Limited to DriveNative so legacy native containers keep receiving Backbone pages only.
     * Backbone's "ui/-/inspections/main" is reported as "ui/inspections/main".
     * Other React pages (coaching, driver safety, cold chain) still report nothing, so DriveNative keeps the previous title.
     */
    notifyDriveNativeOfInspectionsPage(page: string) {
        if (page.indexOf("inspections") === -1 || typeof window.ReactNativeWebView?.postMessage !== "function") {
            return;
        }
        window.webViewLayer?.pageNavigation(page.replace(/^(ui\/)?\/?-\//, "ui/"));
    }

    getAliases() {
        /**
         * Publicly supported page aliases that should never be removed or modified without prior notice
         * to anyone using the app in embedded mode
         */

        return {
            "assets": "assets/main",
            "hos": "hos/tabs/main/main",
            "hos/main": "hos/tabs/main/main", // Some integrators use hos/main as their alias
            "hos/logs": "hos/tabs/logs/logs", // redundant for now, but handles if we ever decide to move the logs page
            "dvir": "dvir/main",
            "messaging": MESSAGING_URL,
            "inspection": "inspection/main",
            "settings": "settings/main",
            "assets/selectShipment": "ui/assets/selectShipment",
            "assets/selectTrailer": "ui/assets/selectTrailer",
            "assets/selectVehicle": "ui/assets/selectVehicle",
            "dvir/view": "ui/dvir/view",
            "hos/addLog": "ui/hos/tabs/logs/addLog",
            "hos/emailLogs": "ui/emailLogs/main",
            "other": "ui/other/main",
            "trips": "ui/trips/main",
            // Self-alias, not a redirect: "main" already loads the dashboard (ui/main) from the hash.
            "main": "main"
        };
    }

    private isStateWithCredentials (s: IRouterPageState) {
        return !!(s && s.credentials && s.credentials.sessionId && s.credentials.database && s.credentials.userName);
    }

    private isAlreadyLoggedIn(s: IRouterPageState) {
        let currentCredentials = this.driveApp?.api?.getCurrentCredentials();
        return currentCredentials && s.credentials && s.credentials.database === currentCredentials.credentials.database &&
            s.credentials.userName === currentCredentials.credentials.userName && s.server === currentCredentials.server &&
            s.credentials.sessionId === currentCredentials.credentials.sessionId;
    }

    private getLoginParams(page: string, state: IRouterPageState) {
        let stateAfterLogin = this.getPageStateWithoutCredentials(state);

        let params: IRouterPageState = {
            loggingIn: true,
            credentials: state.credentials,
            next: `${ page },${ rison.encode(stateAfterLogin) }`,
            cleanUp: !!state.cleanUp
        };

        if (state.server) {
            params.server = state.server;
        }

        return params;
    }

    private getPageStateWithoutCredentials(state: IRouterPageState) {
        let stateAfterLogin = extend({}, state);
        delete stateAfterLogin.credentials;

        if (stateAfterLogin.server) {
            delete stateAfterLogin.server;
        }

        if (stateAfterLogin.cleanUp) {
            delete stateAfterLogin.cleanUp;
        }
        return stateAfterLogin;
    }

    private getPageModule(route: string) {
        return this.pageModules[route];
    }

    private logLoginViewEvent(message: string) {
        logger.event(logger.Event.DEBUG_LOGINVIEW_NAVIGATE, message, this.driveApp.userService.getCurrentUser());
    }
}
